import FnrInput2 from "UI/FnrInput2/FnrInput2";
import FnrTextEditor from "UI/FnrTextEditor/FnrTextEditor";

import ExtendedFieldErrorMessage from "./ExtendedFieldErrorMessage";
import getIconName from "./getIconName";
import { Label, RequiredIcon } from "./styles";

export default function TextField({
  value,
  onChange,
  field = {},
  accentColor = "inherit",
  error,
}) {
  const { icon, multiline, title, inputIsRequired } = field;

  return (
    <div>
      <Label>
        {title}
        {inputIsRequired && <RequiredIcon />}
      </Label>
      {multiline ? (
        <FnrTextEditor
          content={value}
          setContent={onChange}
          menuButtons={[]}
          lineHeight="1.5rem"
          style={{
            boxShadow: "none",
            borderColor: "rgb(224, 224, 224)",
            fontSize: "18px",
            fontWeight: 400,
            color: "#4c5464",
          }}
        />
      ) : (
        <FnrInput2
          value={value}
          setValue={onChange}
          multiline={multiline}
          icon={getIconName(icon)}
          focusColor={accentColor}
          iconColor={accentColor}
          focusSize="2px"
          textColor="#222"
          style={{ fontWeight: 400 }}
          iconSize="18px"
        />
      )}
      {error && <ExtendedFieldErrorMessage>{error}</ExtendedFieldErrorMessage>}
    </div>
  );
}
